import graphql__2db0f2e354eab86b8d5e from "./__generated__/PostSignUpFormMutation.graphql.js";import { commitMutation } from "react-relay";
import { graphql } from "react-relay";
import appRelayEnvironment from "../config/AppRelayEnvironment";
import omit from "lodash/omit";

import serializeAnswers from "../helpers/serializeAnswers";

const consentFields = ["emailConsent", "emailTrackingConsent"];

const mutation = graphql__2db0f2e354eab86b8d5e;

function postSignUpForm(form, onCompleted) {
  const variables = {
    emailConsent: form.fields.emailConsent?.checked,
    emailTrackingConsent: form.fields.emailTrackingConsent?.checked
  };

  variables.answers = serializeAnswers({
    ...form,
    fields: omit(form.fields, consentFields),
    schema: omit(form.schema, consentFields)
  });

  return commitMutation(appRelayEnvironment, {
    mutation,
    variables,
    onCompleted,
    onError: error => console.error(error)
  });
}

export { postSignUpForm };
